<template>
  <v-dialog v-model="dialog" max-width="500px" persistent>
    <v-card>
      <v-card-title class="title">
        {{ selectedLanguage ? 'Sửa ngôn ngữ' : 'Thêm ngôn ngữ' }}
      </v-card-title>
      <v-card-text>
        <v-form ref="form" lazy-validation class="white mt-3">
        <v-text-field
          ref="languageKey"
          v-model="languageKey"
          label="Khoá"
          :rules="[validate.required]"
        ></v-text-field>
        <v-textarea
          ref="vietnamese"
          v-model="vietnamese"
          label="Tiếng Việt"
          :rules="[validate.required]"
        ></v-textarea>
         <v-textarea
          ref="english"
          v-model="english"
          label="Tiếng Anh"
          :rules="[validate.required]"
        ></v-textarea>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey" flat @click="close">Hủy</v-btn>
        <v-btn color="primary" @click="onSubmit" :loading="loading">{{ selectedLanguage ? 'Sửa' : 'Thêm' }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';
import validate from '../../utils/validate';
export default {
  props: { },

  data: () => ({
    dialog: false,
    selectedLanguage: null,
    loading: false,
    languageKey: '',
    vietnamese: '',
    english: '',
    validate: validate
  }),

  methods: {
    ...mapActions(['updateLanguage']),

    open (selectedLanguage) {
      this.dialog = true;
      if (selectedLanguage) {
        this.selectedLanguage = selectedLanguage;
        this.languageKey = selectedLanguage.key;
        this.vietnamese = selectedLanguage['vi-VN'];
        this.english = selectedLanguage['en-US'];
      }
    },

    onSubmit () {
      if (this.$refs.form.validate()) {
        const request = {
          [this.languageKey]: {
            'vi-VN': this.vietnamese,
            'en-US': this.english
          }
        };

        this.loading = true;
        this.updateLanguage(request).then(() => {
          window.getApp.showMessage('Cập nhật ngôn ngữ thành công', 'success');
          this.$emit('success', true);
          this.close();
        }).catch(_ => {
          this.loading = false;
          window.getApp.showMessage('Lỗi khi cập nhật ngôn ngữ', 'error');
        });
      }
    },

    close () {
      this.dialog = false;
      this.loading = false;
      this.reset();
    },

    reset () {
      this.selectedLanguage = null;
      this.languageKey = '';
      this.vietnamese = '';
      this.english = '';
      this.$refs.form.reset();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/language/DialogCreateUpdateLanguage.vue